import type { ReactNode } from "react";

import { IgNumericalCounter } from "@intelligems/ig-theme/IgNumericalCounter";
import { IgSwitch } from "@intelligems/ig-theme/IgSwitch";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";

import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

interface GeneralSectionProps {
  maxProducts: number;
  excludeOutOfStock: boolean;
  excludeItemsInCart: boolean;
  onChange: (changes: {
    maxProducts?: number;
    excludeOutOfStock?: boolean;
    excludeItemsInCart?: boolean;
  }) => void;
  children?: ReactNode;
}

// Product-selection settings, shown above the rules.
export const GeneralSection = ({
  maxProducts,
  excludeOutOfStock,
  excludeItemsInCart,
  onChange,
  children,
}: GeneralSectionProps) => (
  <Stack spacing={5}>
    <Panel.Header>General</Panel.Header>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IgTypography>Exclude out of stock items</IgTypography>
      <IgSwitch
        checked={excludeOutOfStock}
        onChange={(_, checked) => onChange({ excludeOutOfStock: checked })}
      />
    </Stack>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IgTypography>Exclude products in cart</IgTypography>
      <IgSwitch
        checked={excludeItemsInCart}
        onChange={(_, checked) => onChange({ excludeItemsInCart: checked })}
      />
    </Stack>
    {children}
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IgTypography>Number of products to show</IgTypography>
      <IgNumericalCounter
        value={maxProducts}
        min={1}
        max={10}
        onChange={(value) => value != null && onChange({ maxProducts: value })}
      />
    </Stack>
  </Stack>
);
